import React from "react";
import ImageSlider from "./ImageSlider";
import "../style/about.css";

const About = () => {
  return (
    <div className="about">
        <div className="static-image-container">
            <img src="/Images/Slider3.jpg" alt="Witamy w KompLand" className="static-image" />
        </div>

      <section className="about-intro">
        <h2>O Firmie</h2>
        <p>
          Firma nasza istnieje od 2002 roku. Specjalizujemy się w utrzymaniu i obsłudze infrastruktury IT dla:
        </p>
        <div className="about-cards">
          <div className="about-card">🏛️ Instytucje administracji samorządowej</div>
          <div className="about-card">🏥 Instytucje medyczne</div>
          <div className="about-card">🏢 Firmy</div>
        </div>
      </section>

      <section className="about-expertise">
        <h3>Doświadczenie i kompetencje</h3>
        <div className="about-cards">
          <div className="about-card">🖥️ Obsługa sieciowo-serwerowa</div>
          <div className="about-card">📦 Obsługa programów</div>
          <div className="about-card">🚀 Wdrażanie oprogramowania</div>
          <div className="about-card">🔧 Nadzór nad sprzętem</div>
        </div>
      </section>

      <section className="about-footer">
        <p>
          Jesteśmy autoryzowanym partnerem firm: <strong>REKORD SI</strong> (systemy samorządowe) oraz <strong>Asseco Poland</strong> (systemy medyczne).
        </p>
      </section>
    </div>
  );
};

export default About;
